import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger, DialogFooter } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RegisterDialog = ({ kind = 'event', refId, title, label = 'Register', triggerClassName, variant, testid }) => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', phone: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await axios.post(`${API}/events/register`, { kind, ref_id: refId, title, ...form }, { headers });
      toast({ title: 'You\'re registered! 🎉', description: `We\'ll email details for "${title}" soon.` });
      setForm({ name: '', email: '', phone: '' });
      setOpen(false);
    } catch (err) {
      const status = err.response?.status;
      const msg = status === 401 || status === 403
        ? 'Please log in to register for events.'
        : err.response?.data?.detail || 'Please try again.';
      toast({ title: 'Registration failed', description: msg, variant: 'destructive' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          variant={variant}
          data-testid={testid || 'register-trigger'}
          className={triggerClassName || 'rounded-full bg-[#E74C3C] hover:bg-[#C0392B] text-white'}
        >
          {label}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md rounded-3xl">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-[#003366]">Register for {title}</DialogTitle>
          <DialogDescription>Free to attend. We'll email you the joining details.</DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-2">
          <div>
            <Label htmlFor="reg-name">Full Name *</Label>
            <Input id="reg-name" name="name" value={form.name} onChange={handleChange} required className="mt-1.5 rounded-xl" data-testid="reg-name" />
          </div>
          <div>
            <Label htmlFor="reg-email">Email *</Label>
            <Input id="reg-email" name="email" type="email" value={form.email} onChange={handleChange} required className="mt-1.5 rounded-xl" data-testid="reg-email" />
          </div>
          <div>
            <Label htmlFor="reg-phone">Phone</Label>
            <Input id="reg-phone" name="phone" value={form.phone} onChange={handleChange} className="mt-1.5 rounded-xl" data-testid="reg-phone" />
          </div>
          <DialogFooter>
            <Button type="submit" disabled={submitting} data-testid="reg-submit" className="w-full rounded-full bg-[#E74C3C] hover:bg-[#C0392B] text-white">
              {submitting ? 'Registering...' : 'Confirm Registration'}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterDialog;
